import { Box, Typography, Grid } from "@material-ui/core";

export * from "./Sip";
export * from "./NewPurchase";
export * from "./AdditionalPurchase";
export * from "./Stp";
export * from "./Switch";
export * from "./Redemption";
export * from "./Swp";

export const AmcHeader = ({ amcName }: { amcName: string }) => {
  return (
    <Box
      sx={{
        bgcolor: "rgba(0, 124, 197, 0.07)",
      }}
    >
      <Typography
        style={{
          fontFamily: "OpenSans-SemiBold",
          padding: "18px",
          fontSize: "18px",
        }}
      >
        {amcName}
      </Typography>
    </Box>
  );
};

export const Disclaimer = ({ disclaimer }: { disclaimer: string }) => (
  <Box
    sx={{
      bgcolor: "rgba(0, 124, 197, 0.07)",
    }}
  >
    <Typography
      style={{
        padding: "12px",
        fontSize: "12px",
      }}
    >
      {disclaimer}
    </Typography>
  </Box>
);

export const SubTotal = ({
  amount,
  count,
}: {
  amount: string | number;
  count: string | number;
}) => {
  return (
    <Grid
      container
      style={{
        backgroundColor: "rgba(0, 124, 197, 0.03)",
        marginBottom: "30px",
        padding: "12px",
      }}
    >
      <Grid item xs={9}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              style={{
                fontWeight: "600",
              }}
            >
              Sub Total ({count} Schemes)
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <Box display="flex">
          <Typography
            style={{
              color: "#919191",
              fontWeight: "900",
              marginRight: "20px",
            }}
          >
            Amount
          </Typography>
          <Typography style={{ fontWeight: "bolder" }}>
            {"\u20B9" + amount}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export const TransactionHeader = ({ trType }: { trType: string }) => {
  return (
    <Typography
      style={{
        padding: "12px",
        fontFamily: "OpenSans-SemiBold",
        fontWeight: "700",
        fontSize: "18px",
        color: "#007CC5",
      }}
    >
      {trType}
    </Typography>
  );
};

export const SchemeData = ({ name, value }: { name: string; value: any }) => {
  return (
    <Grid item xs={12} lg={6}>
      <Box display={"flex"}>
        <Typography
          style={{
            color: "#919191",
            fontWeight: "600",
            marginRight: "20px",
            marginBottom: "12px",
            fontSize: "14px",
          }}
        >
          {name}
        </Typography>

        <Typography style={{ fontWeight: "bold", fontSize: "15px" }}>
          {String(value)}
        </Typography>
      </Box>
    </Grid>
  );
};
